import useMedia from '~hooks/useMedia';
import useAdminStore from '~store/admin';

import RowClosing from './RowClosing';
import RowDelete from './RowDelete';
import RowDetail from './RowDetail';
import * as S from './style';

export default function Preferences() {
  const { isAdmin } = useAdminStore();
  const { isDesktop } = useMedia();

  if (!isAdmin || !isDesktop) {
    return null;
  }

  return (
    <S.Wrapper>
      <S.Contents>
        <RowDetail />
        <RowClosing />
        <RowDelete />
      </S.Contents>
    </S.Wrapper>
  );
}
